import axiosInstance from "@/lib/axios";

export interface legalDocument {
    id: number;
    doc_type: string;
    doc_type_display: string;
    version: string;
    title: string;
    content: string;
    effective_date: string;
}

export interface complianceFlags {
    profile_incomplete: boolean;
    pending_documents: Array<{ doc_type: string; title: string; version: string }>;
}

export interface myData {
    id: number;
    email: string;
    identifier: string;
    first_name: string;
    second_name?: string;
    last_name: string;
    second_last_name?: string;
    date_of_birth: string | null;
    role: string;
    institution: string | null;
    is_minor: boolean | null;
    participations: Array<{
        simulation: string;
        global_score: number | null;
        global_percentile: string | null;
        is_processed: boolean;
        created_at: string;
    }>;
}

export const getCurrentLegalDocument = async (
    type: string = "policy",
): Promise<legalDocument> => {
    const { data } = await axiosInstance.get<legalDocument>(
        `/compliance/legal-documents/current/?type=${type}`,
    );
    return data;
};

export const acceptPolicy = async (
    docType: string = "policy",
): Promise<void> => {
    await axiosInstance.post("/compliance/acceptances/", { doc_type: docType });
};

export const completeProfile = async (
    dateOfBirth: string,
): Promise<complianceFlags> => {
    const { data } = await axiosInstance.patch<complianceFlags>(
        "/compliance/me/complete-profile/",
        { date_of_birth: dateOfBirth },
    );
    return data;
};

export const getMyData = async (): Promise<myData> => {
    const { data } = await axiosInstance.get<myData>("/compliance/me/");
    return data;
};

export const updateMyData = async (
    payload: Partial<myData>,
): Promise<myData> => {
    const { data } = await axiosInstance.patch<myData>("/compliance/me/", payload);
    return data;
};

export const exportMyData = async (): Promise<Blob> => {
    const { data } = await axiosInstance.get("/compliance/me/export/", {
        responseType: "blob",
    });
    return data;
};

export const deleteMyAccount = async (): Promise<void> => {
    await axiosInstance.post("/compliance/me/delete-account/");
};
